import React, { Component } from "react";
import { connect } from "react-redux";
import ListErrorPrompt from "../../../../../../components/ListErrorPrompt";
import ChooseSubjectTip from "../../../../../../components/ChooseSubjectTip";
import "./style.css";
import "../../../../../../index.css";
import { get, post } from "../../../../../../utils/request";
import { getQueryValue } from "../../../../../../utils/tool";
class SchoolSubject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }
  componentDidMount() {
    if (this.props.type === "subject") {
      this.requestSchoolSubjectToMajors();
    } else {
      if (getQueryValue("from") === "majorquery/list") {
        this.requestSchoolMajorToMajors();
      } else {
        this.requestSchoolSubject();
      }
    }
  }
  componentWillReceiveProps() {
    setTimeout(() => {
      if (this.props.from === "/intelligentbigdata/home") {
        this.requestSchoolSubject();
      }
    });
  }
  render() {
    /**
     * 属性visible控制是否显示
     *
     */
    const { visible } = this.props;
    return (
      <div
        className="school_subject_box"
        style={{ display: visible === true ? "block" : "none" }}
      >
        <ChooseSubjectTip></ChooseSubjectTip>
        {this.state.data === null || this.state.data.length === 0 ? (
          <ListErrorPrompt
            toptext="选科要求未公布，如有招生"
            bottomtext="会在当年招生计划中公布"
          ></ListErrorPrompt>
        ) : (
          this.state.data.map((item, index) => {
            return (
              <div key={index} className="school_subject_box_item">
                <div className="school_subject_box_item_type">
                  <div className="school_subject_box_rectangle fl"></div>
                  <div style={{ width: "95%", lineHeight: 1.3 }} className="fl">
                    专业(类)名称：{item.majorType}
                  </div>
                  <div className="clear"></div>
                </div>
                <div className="school_subject_box_item_majors">
                  类中所含专业：{item.majors}
                </div>
                <div className="school_subject_box_item_subject">
                  <div
                    style={{
                      backgroundColor:
                        item.level === "专科" ? "#8bbded" : "#ff9b00",
                    }}
                    className="fl school_subject_box_level"
                  >
                    {item.level}
                  </div>
                  <div
                    style={{
                      borderColor: item.subjectColor,
                      color: item.subjectColor,
                    }}
                    className="fl school_subject_box_subject"
                  >
                    {item.requireSubject}
                  </div>
                  <div className="clear"></div>
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  }
  /**
   * 请求院校选科
   */
  requestSchoolSubject() {
    let hashId = this.props.hashId;
    let year = 2020;
    get("/public/v1/school/subject/" + hashId + "/" + year).then((res) => {
      this.setState({
        data: res.data,
      });
    });
  }

  /**
   * 通过选考科目获取院校符合选科要求的专业
   */
  requestSchoolSubjectToMajors() {
    let hashId = this.props.hashId;
    let sessionSubject = JSON.parse(sessionStorage.getItem("suject"));
    let subjectIds;
    // 先看看sessionStorage有没有suject的数据，如果没有去redux里面看看
    if (sessionSubject === null) {
      subjectIds = this.props.subject;
    } else {
      subjectIds = sessionSubject;
    }
    let limits = this.props.subject2schoolFilter.limitFilterId;
    let schoolLevelIds = this.props.subject2schoolFilter.levelFilterId;
    let params = {
      hashId: hashId,
      subjectIds: subjectIds,
      limits: limits,
      schoolLevelIds: schoolLevelIds,
    };
    post("/public/v1/school/subject/majors", params).then((res) => {
      this.setState({
        data: res.data,
      });
    });
  }

  /**
   * 选科查询院校使用的返回选科数据的函数
   */
  requestSchoolMajorToMajors() {
    let hashId = this.props.hashId;
    let limits = this.props.major2schoolfilter.limitFilterId;
    let params = {
      hashId: hashId,
      year: 2020,
      limits: limits,
    };
    post("/public/v1/school/major/majors", params).then((res) => {
      this.setState({
        data: res.data,
      });
    });
  }
}
const mapStateToProps = (state) => {
  return {
    subject2schoolFilter: state.subject2schoolfilter.schoolFilterData,
    major2schoolfilter: state.major2schoolfilter.schoolFilterData,
    subject: state.subjectquery.subjectData.subject,
  };
};
export default connect(mapStateToProps)(SchoolSubject);



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailDown/components/SchoolSubject/index.js